<template>
    <div>
        <h4>
            Persistent Menu <a href="javascript:void(0);" class="btn btn-primary transparent btn-sm" @click="isEdit = true" v-if="!isEdit"><span class="glyphicon glyphicon-pencil"></span> Edit</a>
        </h4>
        <span class="small">Persistent Menu คือ Menu ที่จะแสดงด้านล่างของหน้า Facebook Messenger Chat สามารถตั้งค่าเป็นคำที่ไม่เกิน 20 ตัวอักษรได้</span>

        <div style="padding-top: 25px; padding-bottom: 25px" v-if="loading">
            <scale-loader :color="$store.state.theme.brand_color" height="45px" width="7px"></scale-loader>
        </div>
        <template v-else>

        <div class="row" style="margin-top: 10px;">
            <div class="col-sm-6 col-md-4" style="margin-bottom: 10px">
                <div>
                    <ul style="padding: 0;margin: 0;border: 1px solid #dddfe2;">
                        <li style="list-style-type: none; padding: 10px 0px;color: black;text-align: center">
                            <strong>Menu</strong>
                        </li>
                        <li v-for="(menu, index) in persistent_menu" :key="'menu_'+index" style="position:relative;list-style-type: none; border-top: 1px solid #dddfe2;padding: 10px 0px;">
                            
                            <add-button-persistent-menu v-model="persistent_menu[index]" @onDelete="deleteMenu(index)" @onSelectNested="selectNestedMenu(index)" :hasNested="true" :onEdit="isEdit"></add-button-persistent-menu>
                            
                            <!-- <a href="javascript:void(0);" style="width: 22px;margin-top: 8px;display: inline-block" v-if="menu.type == 'postback' && isEdit" @click="createSubMenu(index)"><span class="glyphicon glyphicon-plus"></span></a> -->
                            <div class="clearfix"></div>
                        </li>

                        <li v-if="isEdit && persistent_menu.length < 3" style="list-style-type: none; border-top: 1px solid #dddfe2;padding: 10px 0px;overflow:auto;text-align: center">
                            <a href="javascript:void(0);" @click="addMenu">
                                <span class="glyphicon glyphicon-plus"></span> Add Menu
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
            <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                <div v-if="current_sub_persistent_menu != null && persistent_menu[current_sub_persistent_menu] && persistent_menu[current_sub_persistent_menu].call_to_actions">

                    <div class="col-sm-6 col-md-2 text-center" style="font-size: 32px;">
                        <span class="hidden-xs glyphicon glyphicon-menu-right"></span>
                        <span class="hidden-sm hidden-md hidden-lg glyphicon glyphicon-menu-up"></span>
                    </div>
                    <div class="col-sm-6 col-md-4" >
                        <div>
                            <ul style="padding: 0;margin: 0;border: 1px solid #dddfe2;">
                                <li style="list-style-type: none; padding: 10px 0px;color: black;text-align: center">
                                    <div class="row">
                                        <div class="col-xs-3 hidden-xs text-center"><a href="javascript:void(0);" style="width: 22px" @click="current_sub_persistent_menu = null"><span class="glyphicon glyphicon-menu-left"></span></a></div>
                                        <div class="col-xs-3 hidden-sm hidden-md hidden-lg text-center"><a href="javascript:void(0);" style="width: 22px" @click="current_sub_persistent_menu = null"><span class="glyphicon glyphicon-menu-up"></span></a></div>
                                        <div class="col-xs-6"><strong>Sub Menu</strong></div>
                                        <!-- <div class="col-xs-2" v-if="isEdit"><a href="javascript:void(0);" @click="deleteAllSubMenu"><span class="glyphicon glyphicon-trash"></span></a></div> -->
                                    </div>
                                </li>
                                <li v-for="(menu, index) in persistent_menu[current_sub_persistent_menu].call_to_actions" :key="'sub_menu_'+current_sub_persistent_menu + '_' +index" style="list-style-type: none; border-top: 1px solid #dddfe2;padding: 10px 0px;overflow:auto">
                                    <add-button-persistent-menu v-model="persistent_menu[current_sub_persistent_menu].call_to_actions[index]" @onDelete="deleteSubMenu(index)" :onEdit="isEdit"></add-button-persistent-menu>

                                    <div class="clearfix"></div>
                                    
                                </li>
                                <li v-if="isEdit && persistent_menu[current_sub_persistent_menu].call_to_actions.length < 3" style="list-style-type: none; border-top: 1px solid #dddfe2;padding: 10px 0px;overflow:auto;text-align: center">
                                    <a href="javascript:void(0);" @click="addSubMenu">
                                        <span class="glyphicon glyphicon-plus"></span> Add Sub Menu
                                    </a>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div class="clearfix">  </div>

        <p class="small" v-if="isError" style="color: red">The persistent menu can not be empty</p>
        <p class="small" v-if="isTimeout" style="color: red">Please try again 10 minutes later</p>

        
        <div class="text-center" style="margin-top: 25px;margin-bottom: 25px;">
            <template v-if="isEdit">
                <a href="javascript:void(0);" class="btn btn-default" @click="cancelEdit">Cancel</a>
                <a href="javascript:void(0);" class="btn btn-primary" @click="savePersistentMenu">Save</a>
            </template>
            
        </div>

        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '@/config'
import axios from 'axios'
import api from '@/api'

import AddButtonPersistentMenu from './AddButtonPersistentMenu'

import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

    export default {
        props: ['value'],
        data: function(){
            return {
                isEdit: false,
                persistent_menu: [],
                sub_persistent_menu: [],
                current_sub_persistent_menu: null,
                isError: false,
                isTimeout: false,
                loading: true,
            }
        },
        components: {
            AddButtonPersistentMenu,
            ScaleLoader
        },
        computed: {
			...mapGetters({
				selectedBot: 'selectedBot'
			}),
        },
        created: function(){
            var vm = this
                vm.loading = true
                vm.getPersistentMenu(function(persistent){
                    vm.persistent_menu = []
                    $.each(persistent,function(index,val){
                        vm.persistent_menu.push(Object.assign({},val))
                        if (val.type == 'nested') {
                            vm.persistent_menu[index].call_to_actions = []
                            $.each(val.call_to_actions,function(sindex,sub_val){
                                vm.persistent_menu[index].call_to_actions.push(Object.assign({},sub_val))
                            })
                        }
                    })
                    vm.cached_persistent_menu = []
                    $.each(persistent,function(index,val){
                        vm.cached_persistent_menu.push(Object.assign({},val))
                        if (val.type == 'nested') {
                            vm.cached_persistent_menu[index].call_to_actions = []
                            $.each(val.call_to_actions,function(sindex,sub_val){
                                vm.cached_persistent_menu[index].call_to_actions.push(Object.assign({},sub_val))
                            })
                        }
                    })

                    vm.loading = false
                })
        },
        methods: {
            getPersistentMenu: function(callback){
                var vm = this
                var data = {
                    pageid: vm.selectedBot.pageid,
                    status: vm.selectedBot.status,
                    access_token: vm.selectedBot.page_access_token
                }
                
                api.getPersistentMenu(data, function(error, response){
                    if (error) {
                        console.error(error)
                        
                        return
                    }
                    if (response.data && response.data[0] && response.data[0].persistent_menu && response.data[0].persistent_menu[0] && response.data[0].persistent_menu[0].call_to_actions) {
                        
                        callback(response.data[0].persistent_menu[0].call_to_actions)
                    } else {
                        callback([])
                    }
                })
            },
            savePersistentMenu: function(){
                // if (this.isTimeout) {
                //     return false
                // }
                var vm = this
                var data = {
                    "persistent_menu": [
                        {
                        "locale": "default",
                        "composer_input_disabled": false,
                        "call_to_actions": [
                        ]
                        }
                    ]
                }

                vm.isError = false
                if (vm.persistent_menu) {
                    if (vm.persistent_menu.length == 0) {
                        vm.isError = true
                    }
                    $.each(vm.persistent_menu,function(index,menu){
                        if (menu.title == '' || menu.title == null) {
                            vm.isError = true
                        }
                        
                        if (menu.type == 'postback') {
                            data.persistent_menu[0].call_to_actions.push({
                                "title": menu.title,
                                "type": "postback",
                                "payload": menu.payload
                            })
                        } else if(menu.type == 'web_url') {
                            data.persistent_menu[0].call_to_actions.push({
                                "title": menu.title,
                                "type": "web_url",
                                "url": menu.url,
                                "webview_height_ratio": menu.webview_height_ratio
                            })
                        } else if(menu.type == 'nested'){
                            var nested = []
                            $.each(menu.call_to_actions,function(sindex, sub_menu){
                                if (sub_menu.title == '' || sub_menu.title == null) {
                                    vm.isError = true
                                }
                                nested.push({
                                    "title": sub_menu.title,
                                    "type": "postback",
                                    "payload": sub_menu.title
                                })
                            })
                            if (menu.call_to_actions.length == 0) {
                                vm.isError = true
                            }
                            data.persistent_menu[0].call_to_actions.push({
                                "title": menu.title,
                                "type": "nested",
                                "call_to_actions": nested
                            })
                        }

                    })
                }

                if (vm.isError) {
                    return false
                }

                data.pageid = vm.selectedBot.pageid
                data.status = vm.selectedBot.status
                data.access_token = vm.selectedBot.page_access_token

                vm.$store.dispatch('loading')
                api.editPersistentMenu(data, function(error, response){
                    if (error) {
                        console.error(error)
                        vm.$store.dispatch('loading')
                        return
                    }

                    var response = response.data
                    vm.cached_persistent_menu = []
                    $.each(vm.persistent_menu,function(index,val){
                        vm.cached_persistent_menu.push(Object.assign({},val))
                        if (val.type == 'nested') {
                            vm.cached_persistent_menu[index].call_to_actions = []
                            $.each(val.call_to_actions,function(sindex,sub_val){
                                vm.cached_persistent_menu[index].call_to_actions.push(Object.assign({},sub_val))
                            })
                        }
                    })
                    vm.isEdit = false
                    vm.isError = false
                    vm.isTimeout = false
                    vm.$store.dispatch('loading')
                })
            },
            cancelEdit: function(){
                var vm = this
                vm.persistent_menu = []
                $.each(vm.cached_persistent_menu,function(index,val){
                    vm.persistent_menu.push(Object.assign({},val))
                    if (val.type == 'nested') {
                        vm.persistent_menu[index].call_to_actions = []
                        $.each(val.call_to_actions,function(sindex,sub_val){
                            vm.persistent_menu[index].call_to_actions.push(Object.assign({},sub_val))
                        })
                    }
                })
                this.isEdit = false
                this.isError = false
                this.isTimeout = false
            },
            createSubMenu: function(index){
                this.persistent_menu[index].type = 'nested'
                this.persistent_menu[index]['call_to_actions'] = [
                    {
                        "title": '',
                        "type": "postback",
                        "payload": '',
                        "isShow": true
                    }
                ]
                this.current_sub_persistent_menu = index
            },
            addMenu: function(){
                if (this.persistent_menu.length < 3) {
                    
                    this.persistent_menu.push({
                        "title": '',
                        "type": "postback",
                        "payload": '',
                        "isShow": true
                    })
                }
            },
            addSubMenu: function(){
                // console.log(this.persistent_menu[this.current_sub_persistent_menu]['call_to_actions'].length)
                if (this.persistent_menu[this.current_sub_persistent_menu]['call_to_actions'].length < 3) {
                    
                    var menu = this.persistent_menu[this.current_sub_persistent_menu]['call_to_actions']

                    menu.push({
                        "title": '',
                        "type": "postback",
                        "payload": '',
                        "isShow": true
                    })

                    this.$set(this.persistent_menu[this.current_sub_persistent_menu],'call_to_actions',menu)
                    this.$forceUpdate();


                    
                }
            },
            deleteMenu: function(index){
                this.persistent_menu.splice(index,1)
            },
            deleteSubMenu: function(index){
                this.persistent_menu[this.current_sub_persistent_menu].call_to_actions.splice(index,1)
                this.$forceUpdate();
            },
            deleteAllSubMenu: function(){
                if (this.persistent_menu[this.current_sub_persistent_menu]) {
                    this.persistent_menu[this.current_sub_persistent_menu].type = 'postback'
                    this.persistent_menu[this.current_sub_persistent_menu].payload = this.persistent_menu[this.current_sub_persistent_menu].title
                    delete this.persistent_menu[this.current_sub_persistent_menu].call_to_actions
                }
            },
            selectNestedMenu: function(index){
                var vm = this
                vm.current_sub_persistent_menu = null
                setTimeout(() => {
                   vm.current_sub_persistent_menu = index 
                }, 500);
            }
        },
        watch: {
            value: function(){
                var vm = this
                vm.persistent_menu = []
                $.each(vm.value,function(index,val){
                    vm.persistent_menu.push(Object.assign({},val))
                    if (val.type == 'nested') {
                        vm.persistent_menu[index].call_to_actions = []
                        $.each(val.call_to_actions,function(sindex,sub_val){
                            vm.persistent_menu[index].call_to_actions.push(Object.assign({},sub_val))
                        })
                    }
                })
                vm.cached_persistent_menu = []
                $.each(vm.value,function(index,val){
                    vm.cached_persistent_menu.push(Object.assign({},val))
                    if (val.type == 'nested') {
                        vm.cached_persistent_menu[index].call_to_actions = []
                        $.each(val.call_to_actions,function(sindex,sub_val){
                            vm.cached_persistent_menu[index].call_to_actions.push(Object.assign({},sub_val))
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/view/setting/PersistentMenu.vue